(function(){
  var KEY='sens-wishlist';
  function get(){try{return JSON.parse(localStorage.getItem(KEY))||[]}catch(e){return[]}}
  function set(v){localStorage.setItem(KEY,JSON.stringify(v))}
  function paint(el,on){el.style.background=on?'#e3d5ee':'rgba(250,246,239,.85)'}
  function init(){
    document.querySelectorAll('.sens-fav[data-handle]').forEach(function(el){
      var h=el.getAttribute('data-handle');
      paint(el,get().indexOf(h)>-1);
      if(el.dataset.bound)return;el.dataset.bound=1;
      el.addEventListener('click',function(e){
        e.preventDefault();e.stopPropagation();
        var list=get(),i=list.indexOf(h);
        if(i>-1)list.splice(i,1);else list.push(h);
        set(list);paint(el,i===-1);
        var b=document.querySelector('.sens-wl-count');if(b)b.textContent=get().length;
      });
    });
    var b=document.querySelector('.sens-wl-count');if(b)b.textContent=get().length;
    var wrap=document.getElementById('sens-wl-items');
    if(wrap){
      var list=get();
      if(!list.length){wrap.innerHTML='<p style="color:#8d8390;font-size:14px;">no favourites yet — tap the ♥ on any product to save it here.</p>';return}
      list.forEach(function(h){
        fetch('/products/'+h+'.js').then(function(r){return r.json()}).then(function(p){
          var d=document.createElement('div');
          d.style.cssText='display:flex;flex-direction:column;gap:10px;';
          d.innerHTML='<a href="'+p.url+'" style="display:block;aspect-ratio:3/4;overflow:hidden;border-radius:16px;background:#f4f0eb;"><img src="'+(p.featured_image||'')+'" style="width:100%;height:100%;object-fit:cover;"></a>'+
          '<div style="display:flex;justify-content:space-between;gap:8px;align-items:baseline;"><a href="'+p.url+'" style="font:600 14px Gantari,sans-serif;text-transform:lowercase;">'+p.title.toLowerCase()+'</a><span style="font:500 13px \'Instrument Sans\',sans-serif;color:#7a639a;">฿'+(p.price/100).toLocaleString()+'</span></div>'+
          '<button data-remove="'+h+'" style="align-self:flex-start;border:none;background:none;cursor:pointer;font:500 12px \'Instrument Sans\',sans-serif;color:#8d8390;padding:0;border-bottom:1px solid #d9cfe0;">remove</button>';
          wrap.appendChild(d);
          d.querySelector('[data-remove]').addEventListener('click',function(){
            var l=get();l.splice(l.indexOf(h),1);set(l);d.remove();
            var bb=document.querySelector('.sens-wl-count');if(bb)bb.textContent=l.length;
            if(!l.length)wrap.innerHTML='<p style="color:#8d8390;font-size:14px;">no favourites yet.</p>';
          });
        });
      });
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();